export enum KPIDisplayType {
  PERCENTAGE = "percentage",
  NUMBER = "number"
}

export interface KPIDisplayProps {
  title: string;
  kpi: number;
  kpiTotal?: number | undefined;
  kpiSecondary?: number; // For retention KPI (GRR value)
  kpiArray?: Array<{
    value: number;
    metadata?: { key?: string; currency?: boolean; period?: number };
  }>; // For array-based KPIs
  info?: string;
  type?: KPIDisplayType;
  isCurrency: boolean;
  isLoading?: boolean;
  /** Currency the monetary figures are formatted in; USD when omitted. */
  currencyCode?: string;
}
